import React, { useEffect, useState } from 'react';
import { createSearchParams, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, isEmpty, isNil, map } from 'lodash';
import {
  newCheckInAction,
  newNextAction,
  NEW_CHECKIN,
  NEW_NEXT,
} from '../../actions/navigation';

import { parseUrlParams, addLusaHeaderParam } from '../../utils/parseUrlParams';
import Container from '../../components/Container';
import ContentWrapper from '../../components/ContentWrapper';
import ApplicationId from '../../components/ApplicationId';
import FormRow from '../../components/Form/FormRow';
import FormColumn from '../../components/Form/FormColumn';
import Button from '../../components/Button';
import Radio from '../../components/Form/Radio';
import { useConfig } from '../../config/ConfigContext';
import Header from '../../components/Header';
import User from '../../assets/images/pending.svg';
import './style.scss';
import { ricWorkflowName } from '../../utils/appConstants';

const LuwaQuestions = (props) => {
  const config = useConfig();
  const [request, setRequest] = useState({});
  const [isAllFilled, setisAllFilled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [questions, setQuestions] = useState([]);
  const { checkinData, location, fetch, navigate } = props;
  const match = useParams();
  const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');
  const ricWorkFlow = workflowType === ricWorkflowName;
  const attempt = get(checkinData, 'data.attempt');

  const initializeRequest = (_checkinData) => {
    const { conversationId, questionSetId, questions: newQuestions } = get(_checkinData, 'data');
    const internalRequest = {
      ConversationId: conversationId,
      QuestionSetId: questionSetId,
    };
    const answers = newQuestions && newQuestions.map((q) => {
      const { questionId } = q;
      return {
        QuestionId: questionId,
        ChoiceId: null,
      };
    });
    internalRequest.Answers = answers;
    setQuestions(newQuestions);
    setRequest(internalRequest);
  };

  useEffect(() => {
    const params = parseUrlParams(window.location.search);

    if (isEmpty(checkinData)) {
      props.newCheckInAction({
        workflowType,
        key: params.key,
      });
    } else if (!isEmpty(get(checkinData, 'data.questions'))) {
      initializeRequest(checkinData);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    if (
      !get(checkinData, 'data.data.returnUrl', get(checkinData, 'state.data.returnUrl'))
      && ((fetch.isDone[`${NEW_CHECKIN}`] && !fetch.isRunning[`${NEW_CHECKIN}`])
      || (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]))
    ) {
      const params = parseUrlParams(window.location.search);
      let routeUrl = get(checkinData, 'data.url', '').replace(config.hostUrl, '');
      if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
        routeUrl = addLusaHeaderParam(routeUrl);
      }
      navigate(routeUrl);
    }
  }, [checkinData]);

  const handleChange = (event, choiceId) => {
    let answersToUpdate = map(request.Answers, (answer) => answer);
    answersToUpdate = answersToUpdate.map((answer) => {
      if (answer.QuestionId === event.target.name) {
        return {
          ...answer,
          ChoiceId: choiceId,
        };
      }
      return answer;
    });
    const emptyAnswers = answersToUpdate.filter((answer) => answer.ChoiceId === null) || [];
    setRequest({ ...request, Answers: answersToUpdate });
    setisAllFilled(Array.isArray(emptyAnswers) && emptyAnswers.length === 0);
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    if (!isAllFilled) setIsValid(false);
    else setIsValid(true);

    const params = parseUrlParams(window.location.search);
    if (params.key && isAllFilled) {
      setIsLoading(true);
      props.newNextAction({
        data: request,
        workflowType,
        key: params.key,
        success: (response) => {
          let routeUrl = get(response, 'data.url');
          if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
            routeUrl = addLusaHeaderParam(routeUrl);
          }
          setisAllFilled(false);
          setIsLoading(false);
          const checkinData2 = get(response, 'data.questions') && response;
          if (checkinData2) initializeRequest(checkinData2);
          props.navigate(routeUrl);
        },
        fail: (error) => {
          setisAllFilled(false);
          setIsLoading(false);
          props.navigate({
            pathname: addLusaHeaderParam('/luwa/results/denied'),
            search: isNil(params.lusa_header) ? '' : createSearchParams({ lusa_header: params.lusa_header }).toString(),
            state: {
              data: error.data,
            },
          });
        },
      });
    }
  };

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      {get(props.checkinData, 'attributes.entityId') ? (
        <ApplicationId id={get(props.checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
      ) : null}
      <ContentWrapper className="content" style={{ paddingTop: 20, minHeight: 'calc(100vh - 200px)' }}>
        <Container className="container">
          <FormRow>
            <FormColumn>
              <h2 className="text-left heading-h">Identity Verification</h2>
              <div className="d-flex align-items-center">
                <img src={User} alt="User Icon" className="user-image" />
                <div className="pl-10">
                  <div>LendingUSA</div>
                </div>
              </div>
            </FormColumn>
          </FormRow>
          <FormRow>
            <FormColumn>
              {!isLoading && attempt === 2 && (
                <div className="pt-10">
                  <p className="form-note text-left">Sorry, we were unable to confirm your identity. Please try again.</p>
                </div>
              )}
              <h4 className="pt-20 text-left">ID Check - Identification Questions</h4>
              <p className="heading-paragraph pt-10 text-left">
                Please respond to the questions below so that we may verify your identity. Once your identity has been verified, you&#39;ll be able to sign your
                {' '}
                {ricWorkFlow ? 'contract' : 'loan documents'}
                .
              </p>
            </FormColumn>
          </FormRow>
          <FormColumn className="pt-10">
            {questions && questions.map((q) => {
              const { choices, question, questionId } = q;
              return (
                <div className="pt-10" key={questionId}>
                  <FormRow>
                    <strong className="text-left">{question}</strong>
                  </FormRow>
                  <FormColumn className="pt-10">
                    {
                      choices.map((c) => (
                        <FormRow key={c.choiceId}>
                          <div>
                            <div className="d-flex align-items-center radio-element text-left">
                              <Radio value="Answer1" name={questionId} onChange={(e) => handleChange(e, c.choiceId)} label={c.choice} />
                            </div>
                          </div>
                        </FormRow>
                      ))
                    }
                  </FormColumn>
                </div>
              );
            })}
            {!isValid && (
              <div className="pt-10">
                <p className="form-note">Please answer all of the questions provided.</p>
              </div>
            )}
          </FormColumn>
        </Container>
      </ContentWrapper>
      <div className="footer">
        <FormRow>
          <FormColumn>
            <Button
              color="primary"
              className="large buttonStyle"
              onClick={handleSubmitForm}
              isLoading={isLoading}
              isDisabled={isLoading || (request && request.Answers && request.Answers.filter((q) => q.ChoiceId).length !== questions.length)}
              title="Submit"
            />
          </FormColumn>
        </FormRow>
      </div>
    </div>
  );
};

LuwaQuestions.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  newCheckInAction: PropTypes.func.isRequired,
  newNextAction: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

const mapDispatchToProps = {
  newCheckInAction,
  newNextAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(LuwaQuestions);
